"use client";

import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const offices = [{
  city: "Shenzhen HQ",
  address: "High-Tech Park, Nanshan District, Shenzhen, GD 518057",
  phone: "+86-755-2603-9886",
  email: "asia.sales@galabit.com",
  mapImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/map_shenzhen.png"
}, {
  city: "Dubai Hub",
  address: "Dubai Silicon Oasis, DDP Building, Dubai, UAE 341041\n\n",
  phone: "+971-4-501-5632",
  email: "me.sales@galabit.com",
  mapImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/map_dubai_uae.png"
}, {
  city: "London Office",
  address: "15 Bishopsgate, London EC2N 3AR, United Kingdom\n\n",
  phone: "+44-20-7188-9735",
  email: "eu.sales@galabit.com",
  mapImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/map_london.png"
}];
export default function OurOffices() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="135848" id="global-offices" className="dark bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 flex flex-col justify-end h-full">
        <div ref={headerRef} className={`mb-12 text-center transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-sans text-3xl md:text-4xl lg:text-5xl font-bold tracking-tighter mb-4 text-primary uppercase">
            Global Offices
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-sans">
            Nexel Technologies maintains a strategic global presence to support our international B2B partners and infrastructure projects.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 transition-all duration-1000 ease-out delay-200 ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {offices.map((office, index) => <Card key={office.city} data-index={index} className="overflow-hidden border-border/20 bg-card/40 backdrop-blur-xl shadow-2xl hover:border-primary/50 transition-all duration-300 group">
              <div className="relative h-48 w-full overflow-hidden">
                <img src={office.mapImage} alt={`Geographic location of Nexel ${office.city}`} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-110 grayscale brightness-75 group-hover:grayscale-0 group-hover:brightness-100" />
                <div className="absolute inset-0 bg-gradient-to-t from-card to-transparent pointer-events-none" />
              </div>

              <CardHeader className="pb-4">
                <CardTitle className="font-sans text-2xl font-bold tracking-tight text-primary">
                  {office.city}
                </CardTitle>
              </CardHeader>

              <CardContent className="space-y-4">
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                  <span className="text-sm leading-relaxed text-muted-foreground font-mono">
                    {office.address}
                  </span>
                </div>
                
                <div className="flex flex-col gap-3 pt-2 border-t border-border/20">
                  <Link to={`tel:${office.phone}`} className="flex items-center gap-3 text-sm hover:text-primary transition-colors group/link font-mono">
                    <Phone className="w-4 h-4 text-primary group-hover/link:text-primary transition-colors" />
                    <span>{office.phone}</span>
                  </Link>
                  <Link to={`mailto:${office.email}`} className="flex items-center gap-3 text-sm hover:text-primary transition-colors group/link font-mono">
                    <Mail className="w-4 h-4 text-primary group-hover/link:text-primary transition-colors" />
                    <span>{office.email}</span>
                  </Link>
                </div>
              </CardContent>

              <CardFooter className="pt-2 pb-6">
                <Button asChild className="w-full font-bold bg-primary text-primary-foreground hover:bg-primary/90 transition-all rounded-md" size="lg">
                  <Link to={`tel:${office.phone}`}>Contact Regional Sales</Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}